var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-heading-tabs" }, [
    _c("header", { staticClass: "layout-heading-tabs__header" }, [
      _c(
        "div",
        { staticClass: "layout-heading-tabs__container" },
        [
          _c(
            "h1",
            {
              staticClass: "typographies-heading-h1 layout-heading-tabs__title"
            },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _vm._t("tabs")
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-heading-tabs__actions" },
        [_vm._t("actions")],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "layout-heading-tabs__content" },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }